import {BaseModel} from '../../base/models/base-model.model';

export class UnitPropertiesModel extends BaseModel {

  private _certificateDnqFormat?: string;

  private _country?: string;

  private _ippFeAssistanceLink?: string;

  private _language?: string;

  private _privacyPolicyTemplate?: string;

  private _privacyPolicyTenant?: string;

  private _privacyPolicyURL?: string;

  private _identificationTypes?: string[];

  private _raoNumber?: string;

  constructor(certificateDnqFormat?: string, country?: string, ippFeAssistanceLink?: string, language?: string, privacyPolicyTemplate?: string, privacyPolicyTenant?: string, privacyPolicyURL?: string, identificationTypes?: string[], raoNumber?: string) {
    super();
    this._certificateDnqFormat = certificateDnqFormat;
    this._country = country;
    this._ippFeAssistanceLink = ippFeAssistanceLink;
    this._language = language;
    this._privacyPolicyTemplate = privacyPolicyTemplate;
    this._privacyPolicyTenant = privacyPolicyTenant;
    this._privacyPolicyURL = privacyPolicyURL;
    this._identificationTypes = identificationTypes;
    this._raoNumber = raoNumber;

  }

  get certificateDnqFormat(): string {
    return this._certificateDnqFormat;
  }

  set certificateDnqFormat(value: string) {
    this._certificateDnqFormat = value;
  }

  get country(): string {
    return this._country;
  }

  set country(value: string) {
    this._country = value;
  }

  get ippFeAssistanceLink(): string {
    return this._ippFeAssistanceLink;
  }

  set ippFeAssistanceLink(value: string) {
    this._ippFeAssistanceLink = value;
  }

  get language(): string {
    return this._language;
  }

  set language(value: string) {
    this._language = value;
  }

  get privacyPolicyTemplate(): string {
    return this._privacyPolicyTemplate;
  }

  set privacyPolicyTemplate(value: string) {
    this._privacyPolicyTemplate = value;
  }

  get privacyPolicyTenant(): string {
    return this._privacyPolicyTenant;
  }

  set privacyPolicyTenant(value: string) {
    this._privacyPolicyTenant = value;
  }

  get privacyPolicyURL(): string {
    return this._privacyPolicyURL;
  }

  set privacyPolicyURL(value: string) {
    this._privacyPolicyURL = value;
  }

  get identificationTypes(): string[] {
    return this._identificationTypes;
  }

  set identificationTypes(value: string[]) {
    this._identificationTypes = value;
  }

  get raoNumber(): string {
    return this._raoNumber;
  }

  set raoNumber(value: string) {
    this._raoNumber = value;
  }

}
